<script setup lang="ts">
import getPost from "~/graphql/getPost.gql"
import LoadingAnimation from "~/components/utils/LoadingAnimation.vue"

type PostResponse = {
  seo: {
    metaDesc: string
    title: string
  }
  post: {
    header?: string
    title?: string
    subtitle?: string
    date?: string
    author?: {
      node?: {
        firstName?: string
        lastName?: string
      }
    }
    featuredImage?: {
      node: {
        uri: string
      }
    }
  }
}

const route = useRoute()
const urlSlug = route.params.slug
const { data, pending } = await useAsyncQuery(getPost, { slug: urlSlug })
const postResponse: PostResponse = data.value as PostResponse

const fallbackImage = "/images/blog/open_graph_preview.png"
const featureImageUrlSuffix = postResponse.post.featuredImage?.node.uri
const featureImageUrl = featureImageUrlSuffix ? `https://memblog.de${featureImageUrlSuffix}` : fallbackImage

// redirect, for wrong naming
definePageMeta({
  middleware: "redirect-wrong-namings",
})

// SEO Setup
if (postResponse) {
  const head: { title?: string; meta: object[] } = { meta: [] }

  head.meta.push({ property: "og:type", content: "article" })
  head.meta.push({ property: "og:image", content: featureImageUrl })

  if (postResponse.seo && postResponse.seo.title) {
    head.title = postResponse.seo.title
    head.meta.push({ property: "og:title", content: postResponse.seo.title })
  }
  if (postResponse.seo && postResponse.seo.metaDesc) {
    head.meta.push({
      property: "og:description",
      content: postResponse.seo.metaDesc,
    })
    head.meta.push({ name: "description", content: postResponse.seo.metaDesc })
  }
  useHead(head)
}
</script>

<template>
  <div>
    <div v-if="pending" class="container is-flex is-align-items-center is-flex-direction-column">
      <div class="title is-4">Ratgeber wird geladen...</div>
      <LoadingAnimation :has-text="false" />
    </div>
    <div v-else-if="postResponse && postResponse.post">
      <BlogSinglePost :post="postResponse.post" :image-url="featureImageUrl" :slug="urlSlug" />
    </div>
  </div>
</template>
